module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<section id="login_modal" class="pop_modal">\n    <div class="pop colored white">\n        <div class="container-fluid content">\n            <div class="row">\n                <div class="col-xs-12">\n                    <img src="/img/osm_128.png" alt="OpenStreetMap" width="128" height="128" class="img-responsive center-block" />\n                    <p class="text-center" data-l10n-id="loginModal_explanation"></p>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-xs-12 prepend-xs-1">\n                    <button type="button" class="btn btn-default close_btn" data-l10n-id="close"></button>\n                    <a href="/auth?successRedirect=' +
__e( successRedirect ) +
'&failureRedirect=' +
__e( failureRedirect ) +
'" class="btn btn-primary pull-right hidden-xs" data-l10n-id="loginOrSubscribe"></a>\n                    <a href="/auth?successRedirect=' +
__e( successRedirect ) +
'&failureRedirect=' +
__e( failureRedirect ) +
'" class="btn btn-primary pull-right visible-xs" data-l10n-id="login"></a>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./js/templates/loginModal.ejs
// module id = 347
// module chunks = 3